import {
  Box,
  Button,
  Card,
  Checkbox,
  Inline,
  Label,
  Stack
} from "@adfenix/alexandria";
import Divider from "components/Divider";
import Page from "components/Page";
import PageHeader from "components/PageHeader";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { SubmitModal } from "./SubmitModal";
import { integrations, defaultValues } from "./integrations";

/**
 * This page is used to render a form where you can select which integrations you want help with.
 * A submit will result in a RMQ message which will be read by bizops in various services.
 *
 * A request includes what integrations you want help with plus some information about the requester.
 */
export const IntegrationPage = () => {
  const { register, getValues, watch, reset } = useForm({
    defaultValues
  });

  const anySelected = Object.values(watch()).some(x => x === true);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  return (
    <Page
      header={
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <PageHeader title="Integrations" />
        </Box>
      }
    >
      <Card p="m" style={{ marginTop: "16px", maxWidth: "800px" }}>
        <form>
          <Stack spacing="m">
            {integrations.map(integration => {
              const { propertyKey, name, description } = integration;
              return (
                <Box key={propertyKey} style={{ width: "fit-content" }}>
                  <Inline>
                    <Checkbox id={propertyKey} {...register(propertyKey)} />
                    <Label htmlFor={propertyKey} style={{ fontWeight: 600 }}>
                      {name}
                    </Label>
                  </Inline>
                  <Label htmlFor={propertyKey} style={{ marginLeft: "40px" }}>
                    {description}
                  </Label>
                </Box>
              );
            })}

            <Divider margin="0 0 16px 0" />
            <Button
              logLabel="submit-integration-button"
              disabled={!anySelected}
              style={{ marginLeft: "auto" }}
              onClick={() => setShowSubmitModal(true)}
            >
              Request
            </Button>
          </Stack>
          {showSubmitModal && (
            <SubmitModal
              integrationFormState={getValues()}
              setShow={setShowSubmitModal}
              resetForm={() => reset(defaultValues)}
            />
          )}
        </form>
      </Card>
    </Page>
  );
};
